import { lazy, Suspense, type ReactNode } from "react";
import { Navigate, type RouteObject } from "react-router-dom";
import { RouteErrorBoundary } from "./RouteErrorBoundary";

const TemplatesPage = lazy(() => import("@/widgets/template-gallery/TemplatesPage"));
const MinimalTemplatePage = lazy(
  () => import("@/widgets/template-gallery/MinimalTemplatePage"),
);
const TemplateEditorPage = lazy(
  () => import("@/widgets/template-editor/TemplateEditorPage"),
);

const suspend = (node: ReactNode) => (
  <Suspense fallback={<div className="min-h-screen" />}>{node}</Suspense>
);

/**
 * The three Studio surfaces, matching the paths TemplateStudioFrame embeds
 * (`/templates`, `/edit`, `/preview` + ?storeId=&templateId=). No guards:
 * authorization is the editor token's job, not the router's.
 */
export const studioRoutes: RouteObject[] = [
  { path: "/", element: <Navigate to="/templates" replace /> },
  { path: "/templates", element: suspend(<TemplatesPage />) },
  { path: "/edit", element: suspend(<TemplateEditorPage />) },
  { path: "/preview", element: suspend(<MinimalTemplatePage />) },
  { path: "*", element: <Navigate to="/templates" replace /> },
  // Every route above lazy-imports its page, so a deploy landing while a tab
  // is open makes the next navigation throw. Without this, React Router shows
  // its own developer screen ("Unexpected Application Error!", a stack trace,
  // and advice addressed to a developer) — inside the dashboard's iframe, to
  // a merchant, mid-edit.
].map((route) => ({ ...route, errorElement: <RouteErrorBoundary /> }));
